/**
 * Common API response types matching the BFF envelope contract.
 */

/** Error envelope returned by the BFF on non-2xx responses */
export interface ApiErrorPayload {
  error: {
    code: string;
    message: string;
    field?: string;
  };
}

/** Custom error class for structured API errors */
export class ApiError extends Error {
  public readonly status: number;
  public readonly code: string;
  public readonly field?: string;

  constructor(status: number, code: string, message: string, field?: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.field = field;
  }
}

/** Managed environment type (mirrors BFF) */
export type ManagedEnvironment = 'np' | 'prd';
